import type { ComponentProps } from 'react'
import { classNames } from '~/utils/client/helpers'

type TableWrapperProps = {
  innerClassName?: string
} & ComponentProps<'div'>

export const TableWrapper = ({
  children,
  className,
  innerClassName,
  ...props
}: TableWrapperProps) => {
  return (
    <div className={classNames('mx-auto max-w-screen-xl', className)} {...props}>
      <div className={classNames('bg-white relative rounded-lg', innerClassName)}>{children}</div>
    </div>
  )
}
